import { actions } from './slice';
import { getDetailedEcgData, getPatientsStudyData, getStudyStatistic, saveHolterFiles } from './actions';

const allActions = {
  ...actions,
  getDetailedEcgData,
  getPatientsStudyData,
  getStudyStatistic,
  saveHolterFiles,
};

export { allActions as studyActions };
export { reducer as studyReducer } from './slice';
